import React from "react";

export default class FooterFAB extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toggle: false };
  }

  render() {
    return (
      <div className="col-sm-12 text-center footer-fab-form-container">
        <button
          className="col-5 footer-fab-button"
          onClick={() => {
            let toggle = !this.state.toggle;
            this.setState({ toggle }, () => {
              window.scrollTo(0, 100000);
            });
          }}
        >
          빠른상담
        </button>
        {this.state.toggle && (
          <div className="collapse show">
            <div className="form-row b-0">
              <div className="form-group col-md-6">
                <label htmlFor="inputEmail4">이름</label>
                <input
                  ref="name"
                  type="text"
                  className="form-control"
                  id="inputEmail4"
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputPassword4">연락처</label>
                <input
                  ref="phoneNumber"
                  type="text"
                  className="form-control"
                  id="inputPassword4"
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="inputAddress">제목</label>
              <input
                ref="title"
                type="text"
                className="form-control"
                id="inputAddress"
              />
            </div>
            <div className="form-group">
              <label htmlFor="inputAddress2">상담내용</label>
              <textarea
                ref="details"
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="4"
              />
            </div>
            <div className="form-group text-center">
              <button
                onClick={() => {
                  this.props.onSubmit();
                  let toggle = !this.state.toggle;
                  this.setState({ toggle });
                }}
                className="btn btn-primary col-6 my-5"
              >
                신청
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
